import { createSlice } from '@reduxjs/toolkit';
import { createAppAsyncThunk } from '../createAppAsyncThunk';
import { API_POST } from '../../services';
import type { RootState } from '../store';
import { env } from '../../env';
import { ENDPOINTS } from '../../constants/endPoints';
import { RADRequest } from '../../models/common/RADRequest';

interface AdwDashboardsTokenResponse {
  token: string;
}

interface AdwDashboardsTokenState {
  isLoading: boolean;
}

const initialState: AdwDashboardsTokenState = {
  isLoading: false,
};

export const getAdwDashboardsToken = createAppAsyncThunk(
  'adwDashboardsToken/get',
  async (payload: RADRequest) => {
    const requestBody = {
      StoreNumber: payload.storeNumber,
      IsMultiStoreMode: payload.isMultiStoreMode,
    };
    
    const response: AdwDashboardsTokenResponse = await API_POST(
      `${env.RAD_APP_API_URL}${ENDPOINTS.GET_ADW_DASHBOARDS_TOKEN}`,
      requestBody,
    );
    return response;
  }
);

const adwDashboardsTokenSlice = createSlice({
  name: 'adwDashboardsToken',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAdwDashboardsToken.pending, state => {
        state.isLoading = true;
      })
      .addCase(getAdwDashboardsToken.fulfilled, state => {
        state.isLoading = false;
      })
      .addCase(getAdwDashboardsToken.rejected, state => {
        state.isLoading = false;
      });
  },
});

// Selectors
export const selectIsAdwDashboardsTokenLoading = (state: RootState): boolean =>
  state.adwDashboardsToken.isLoading;

export default adwDashboardsTokenSlice.reducer;
